/// <reference path="../types.d.ts" />

import { createAsyncThunk } from '@reduxjs/toolkit';
import { AccountSettings } from './action-types';
import {
  deletePreferenceValues,
  saveUserPreference,
  updatePreferenceValues
} from './user-preferences';
import { commonEnums } from '@codametrix/ui-common';
import { showFeedback } from './feedback.actions';
import { toggleIsOpen } from './account-settings-state.actions';
const { UserPreferenceKey } = commonEnums;

const saveDefaults = createAsyncThunk(
  AccountSettings.SAVE_DEFAULTS,
  async (payload: CMx.SaveAccountDefaultPayload, { dispatch }) => {
    const {
      defaultOrg,
      defaultServiceLine,
      defaultHomepage,
      demographicsPanelLocation,
      demographicsPanelVisibility,
      userId
    } = payload;

    if (defaultOrg === -1) {
      dispatch(
        deletePreferenceValues({
          userId,
          keyname: UserPreferenceKey.DEFAULT_USER_CONTEXT
        })
      );
    } else if (defaultOrg) {
      const defaultOrgPreference: CMx.PreferencePayload = {
        userId,
        value: defaultOrg.toString(),
        keyname: UserPreferenceKey.DEFAULT_USER_CONTEXT
      };
      dispatch(saveUserPreference(defaultOrgPreference));
    }

    if (defaultServiceLine === -1) {
      dispatch(
        deletePreferenceValues({
          userId,
          keyname: UserPreferenceKey.DEFAULT_USER_SERVICE_LINE
        })
      );
    } else if (defaultServiceLine) {
      const defaultServiceLinePreference: CMx.PreferencePayload = {
        userId,
        value: defaultServiceLine.toString(),
        keyname: UserPreferenceKey.DEFAULT_USER_SERVICE_LINE
      };
      dispatch(saveUserPreference(defaultServiceLinePreference));
    }

    if (defaultHomepage) {
      const defaultHomepagePreference: CMx.PreferencePayload = {
        userId,
        value: defaultHomepage.path,
        keyname: UserPreferenceKey.DEFAULT_HOMEPAGE,
        tenantId: defaultHomepage.tenantId
      };

      dispatch(
        updatePreferenceValues({
          userId,
          keyname: UserPreferenceKey.DEFAULT_HOMEPAGE,
          preferenceValue: defaultHomepagePreference
        })
      );
    }

    if (demographicsPanelLocation !== undefined) {
      const locationPreference: CMx.PreferencePayload = {
        userId,
        value: demographicsPanelLocation,
        keyname: UserPreferenceKey.DEMOGRAPHICS_PANEL_LOCATION
      };
      dispatch(saveUserPreference(locationPreference));
    }

    if (demographicsPanelVisibility !== undefined) {
      const visibilityPreference: CMx.PreferencePayload = {
        userId,
        value: demographicsPanelVisibility,
        keyname: UserPreferenceKey.DEMOGRAPHICS_PANEL_VISIBILITY
      };
      dispatch(saveUserPreference(visibilityPreference));
    }

    dispatch(toggleIsOpen(false));
    dispatch(
      showFeedback({
        id: Date.now(),
        message: `Account settings saved`,
        dismissable: true,
        className: 'feedback-working'
      })
    );
  }
);

export { toggleIsOpen, saveDefaults };
export {
  saveFormData,
  updateFormDefinition
} from './account-settings-state.actions';
